import styled from 'styled-components';

import {colors} from 'theme';

import {Tag} from '../../ui-kit/Tags';

export const DataTitle = styled.div`
    color: ${colors.textPrimary};
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 30px;
`;

export const ErrorsWrapper = styled.div`
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    margin-bottom: 20px;
    margin-top: -24px;
`;

export const Error = styled(Tag)`
    padding: 8px 16px;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${colors.white};
    background-color: ${colors.danger};
    border-radius: 6px;
    width: auto;
`;
